<template>
  <div :class="[`navigation`, visible ? `navigation--visible` : ``]">
    <ui-logo />
    <ul class="menu">
      <li :key="navItem.identifier" v-for="navItem in navigation" class="menu__item">

        <span @click="setActive(navItem.identifier)" class="menu__item-label">
          <span :class="[`menu__item-indicator`, activeChapter === navItem.identifier ? `menu__item-indicator--active`: ``]"></span>
          <span class="menu__item-label-title">{{ navItem.title }}</span>

        </span>
        <span @click="setActive(navItem.identifier)" class="menu__item-description">{{ navItem.description }}</span>

        <ul class="menu__sub" :v-if="navItem.children && navItem.children.length > 0">
          <li
            v-for="children in navItem.children"
            :key="children.identifier"
            @click="setActive(navItem.identifier, children.identifier)"
            class="menu__item">

            <span :class="[`menu__item-label`,
                  children.identifier === activeMenuItem && navItem.identifier === activeChapter ? `menu__item-label--active` : ``]">{{ children.title }}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex'
import blocks from '@/models/blocks'
import navigation from '@/models/navigation'

import UiLogo from './Logo'

export default {
  name: `ui-navigation`,

  // Components
  components: {
    UiLogo
  },

  // Data
  data: () => ({
    throttleScroll: false
  }),

  // Computed
  computed: {
    ...mapGetters(`navigation`, [`visible`, `activeMenuItem`, `activeChapter`]),

    menuSubItems () {
      const subMenuItems = []

      _.forEach(blocks, (value, key) => {
        subMenuItems.push(value.name)
      })

      return subMenuItems
    },
    navigation: () => navigation,

    blockItems () {
      const blockItems = []

      _.forEach(blockContent[this.activeMenuItem].rows, (value, key) => {
        blockItems.push(key)
      })

      return blockItems
    }
  },

  // Methods
  methods: {
    ...mapActions(`navigation`, [`toggleNavigation`, `setActiveMenuItem`, `setActiveChapter`]),

    setActive (chapter, block) {
      const activeItem = block || ''

      this.$router.push(`/page/${chapter}/${activeItem}`)
    }

  }
  // Watchers

  // Lifecycles

  // Filters
}
</script>
